import { useRef, useState } from 'react'
import { VIEWS } from '../../containers/auth/modals'
import { useAuth } from '../../contexts/auth'
import MessageModal from '../message-modal'
import useOnScreen from '../../hooks/useOnScreen'
import { Button } from '../button'

export default function Banner() {
  const [{ isAuthenticated }, { setAuthModal }] = useAuth()
  const [alreadyRegisteredModal, setAlreadyRegisteredModal] = useState(false)
  const ref = useRef(null)

  const isVisible = useOnScreen({ target: ref })

  const handleClick = () =>
    isAuthenticated
      ? setAlreadyRegisteredModal(true)
      : setAuthModal({ open: true, view: VIEWS.Register })

  return (
    <div className='bannerContainer'>
      <div className='aligner flex alignCenter justifyBetween'>
        <div className='images' ref={ref}>
          <div className='placeholder desktop'>
            {isVisible && <img src='/images/banner-desktop.png' alt='DrivrzXchange platform' />}
          </div>
          <div className='placeholder mobile'>
            {isVisible && <img src='/images/banner-mobile.png' alt='DrivrzXchange platform' />}
          </div>
        </div>

        <div className='text'>
          <h2 className='title'>
            Buy or sell a vehicle from the comfort of your own home <span>today</span>
          </h2>
          <Button size='lg' onClick={handleClick}>
            Create an account
          </Button>
        </div>
      </div>

      {alreadyRegisteredModal && (
        <MessageModal
          title='Registration'
          text='You are already registered'
          onClose={() => setAlreadyRegisteredModal(false)}
        />
      )}

      <style jsx>{`
        .bannerContainer {
          background: #212529;
          padding: 7.4rem 3.3rem;

          .aligner {
            max-width: 163.3rem;
            width: 100%;
            margin: 0 auto;
            gap: 2rem;
          }

          .images {
            position: relative;
            max-width: 81.8rem;
            width: 100%;
            height: 48rem;

            .placeholder {
              position: absolute;
              border-radius: 3px;

              img {
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }

            .placeholder.desktop {
              top: 0;
              left: 0;
              max-width: 77.3rem;
              width: 100%;
              height: 100%;
            }

            .placeholder.mobile {
              right: 0;
              bottom: 0;
              max-width: 18.5rem;
              width: 11vw;
              height: 37.2rem;
            }
          }

          .text {
            max-width: 72rem;
            width: 100%;
            margin: 0 0 0 2rem;
            color: #fff;

            .title {
              margin: 0 0 1.8rem;
              font-size: 5.4rem;

              span {
                text-decoration: underline;
              }
            }
          }
        }

        .alreadyRegistered {
          padding: 2.6rem 10.4rem 4rem;
          background: #fff;

          h2 {
            font-size: 3.2rem;
          }

          p {
            margin: 2.4rem 0 2.6rem;
            font-size: 1.6rem;
          }
        }

        @media (max-width: 1200px) {
          .bannerContainer {
            .text {
              .title {
                font-size: 4rem;
              }
            }
          }
        }

        @media (max-width: 1024px) {
          .bannerContainer {
            padding: 0 3rem 3rem;
            .aligner {
              flex-direction: column;
            }

            .images {
              height: 80vw;
              max-height: 59.1rem;

              .placeholder.desktop {
                max-width: 100%;
              }

              .placeholder.mobile {
                width: 25vw;

                img {
                  height: unset;
                  position: absolute;
                  bottom: 0;
                }
              }
            }

            .text {
              max-width: 35rem;
              margin: 2rem 0 0;
              text-align: center;

              .title {
                font-size: 2rem;
              }
            }
          }

          .alreadyRegistered {
            padding: 5.4rem 2rem;

            h2 {
              font-size: 1.8rem;
            }

            p {
              margin: 0.8rem 0;
              font-size: 1.4rem;
            }

            :global(.close) {
              position: fixed;
              bottom: 2.1rem;
              width: calc(100% - 2.8rem);
            }
          }
        }
      `}</style>
    </div>
  )
}
